module.exports = __webpack_public_path__ + "img/bz@2x.068b92af.png";